import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazy-load';
import { getCdnImage } from '../../../utils/ImageManager';
import getCdnSrcset from '../../../utils/srcSetHelper';
import styles from './card-tw-styles';
import i18nMessages from '../../../constants/messages/pt-BR';
import Image from 'next/image';

const MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];

function CardMedia(props) {
  const {
    className,
    component: ComponentProp,
    image,
    imgClass,
    src,
    srcset,
    alt,
    sizes,
    cardType,
    mediaVariant,
    lazyLoad,
    pictureLazyLoad,
    height,
    width,
    ...other
  } = props;
  const Component = ComponentProp || 'div';
  const resolvedHeight = typeof height === 'number' ? height : 1000;
  const resolvedWidth = typeof width === 'number' ? width : 1000;

  const isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;

  if (Component === i18nMessages.picture) {
    return (
      pictureLazyLoad ? (
          <>
          <LazyLoad offset={-20}>
          <picture>
            <source
              srcSet={getCdnSrcset(srcset, 1600, 768)}
              media={mediaVariant}
            />
            <Image
              className={styles.cardMediaImg}
              src={getCdnImage(image, { w: 750 })}
              alt={alt || 'img'}
              loading='lazy'
              height={resolvedHeight}
              width={resolvedWidth}
            />
          </picture>
          </LazyLoad>
          </>
      ) : (
        <picture>
          <source
            srcSet={getCdnSrcset(srcset, 1600, 768)}
            media={mediaVariant}
          />
          <Image
            className={styles.cardMediaImg}
            src={getCdnImage(image, { w: 750 })}
            alt={alt || 'img'}
            loading='eager'
            priority={true}
            height={resolvedHeight}
            width={resolvedWidth}
          />
        </picture>
      )
    );
  }

  if (Component === 'img') {

    return (
        <Image
          className={className}
          src={isMediaComponent ? getCdnImage(image, { w: sizes ? sizes : '' }) || getCdnImage(src) : undefined}
          srcSet={srcset}
          loading='eager'
          height={resolvedHeight}
          width={resolvedWidth}
          alt={alt || 'img'}
          {...other}
        />
    );

  } else {

    return (
        <Component
          className={className}
          src={isMediaComponent ? getCdnImage(image, { w: sizes ? sizes : '' }) || getCdnImage(src) : undefined}
          srcSet={srcset}
          height={height}
          width={width}
          alt={alt || 'img'}
          {...other}
        />
    );
  }
}

CardMedia.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Component for rendering image.
   * Either a string to use a DOM element or a component.
   */
  imgClass: PropTypes.string,
  /**
   * Component for rendering image ClassNames.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: PropTypes.string,
  lazyLoad: PropTypes.bool,
  pictureLazyLoad: PropTypes.bool,
  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: PropTypes.string,
  mediaVariant: PropTypes.string,
  /**
   * @ignore
   */
  height: PropTypes.number,
  width: PropTypes.number,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const CardMedia = ({prop = val, component = 'div', className = '', imgClass = '', image = '', src = '', mediaVariant = '(min-width: 1024px)', lazyLoad = false, pictureLazyLoad = true, height = 1000, width = 1000 }) =>

export default CardMedia;
